import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe, TitleCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from '@purespectrum1/ui/button';
import { DropdownModule } from '@purespectrum1/ui/dropdown';
import { ModalModule } from '@purespectrum1/ui/modal';
import { SliderModule } from '@purespectrum1/ui/slider';
import { SelectDropdownModule } from '@purespectrum1/ui/select-dropdown';
import { AccordionModule } from '@purespectrum1/ui/accordion';
import {
  GoogleTagManagerModule,
  HotjarModule,
} from '@purespectrum1/ui/tracking';
import { InputRestrictionModule } from '../shared/ui/input-restriction/input-restriction.module';

import { ZeroDashPipeModule } from '../shared/pipes/zero-dash-pipe.module';
import { ConfigEnabledModule } from '../shared/ui/config-enabled/config-enabled.module';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { CreateSurveyDataComponent } from './header/create-survey-data/create-survey-data.component';
import { ProcessingComponent } from './header/processing/processing.component';
import { FeasibilityComponent } from './header/feasibility/feasibility.component';
import { CpiComponent } from './header/cpi/cpi.component';
import { EditSuppliersComponent } from './edit-suppliers/edit-suppliers.component';
import { EditSuppliersModalComponent } from './edit-suppliers/edit-supplier-modal/edit-suppliers-modal.component';
import { EditSupplierGroupModalComponent } from './edit-suppliers/edit-supplier-group-modal/edit-supplier-group-modal.component';
import { EllipsisLoaderComponent } from './header/ellipsis-loader/ellipsis-loader.component';
import { SupplierAllocationModalComponent } from './header/supplier-allocation-modal/supplier-allocation-modal.component';
import { HasRoleModule } from '../../shared/ui/has-role/has-role.module';
import { TruncateWordPipe } from '../shared/pipes/truncate-word.pipe';
import { TemplateModalComponent } from './template-modal/template-modal.component';
import { DeleteTemplateModalComponent } from './template-modal/delete-template-modal/delete-template-modal.component';
import { SortTableModule } from '../../shared/ui/sort-table/sort-table.module';
import { PdsLabelModule } from '../../shared/ui/pds-label/pds-label.module';
import { SearchFilterPipeModule } from '../shared/pipes/filter-pipe.module';
import { CpiOverrideConfirmationComponent } from './header/cpi/cpi-override-confirmation/cpi-override-confirmation.component';
import { CpiOverrideWarningComponent } from './header/cpi/cpi-override-warning/cpi-override-warning.component';
import { InputDecimalRestrictionModule } from '../../shared/ui/input-decimal-restriction/input-decimal-restriction.module';
import { HeaderServiceAccountComponent } from './header/header-service-account/header-service-account.component';
import { AdvanceFeasibilityComponent } from './header/advance-feasibility/advance-feasibility.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { BlendModalComponent } from './edit-suppliers/blend-modal/blend-modal.component';
import { ToNumberModule } from '../shared/ui/to-number/to-number.module';
import { SortPipe } from '../../shared/pipes/sort-pipe/sort.pipe';
import { TreeDropdownModule } from '../shared/ui/tree-dropdown/tree-dropdown.module';

export * from './footer/footer.component';
export * from './header/header.component';
export * from './edit-suppliers/edit-suppliers.component';
export * from './edit-suppliers/edit-supplier-modal/edit-suppliers-modal.component';
export * from './edit-suppliers/edit-supplier-group-modal/edit-supplier-group-modal.component';
export * from './header/cpi/cpi-override-confirmation/cpi-override-confirmation.component';
export * from './header/cpi/cpi-override-warning/cpi-override-warning.component';
export * from './header/create-survey-data/create-survey-data.component';
export * from './header/header-service-account/header-service-account.component';
export * from './header/ellipsis-loader/ellipsis-loader.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DropdownModule,
    RouterModule,
    ModalModule,
    SliderModule,
    SelectDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    SortTableModule,
    PdsLabelModule,
    AccordionModule,
    ConfigEnabledModule,
    SearchFilterPipeModule,
    HasRoleModule,
    ZeroDashPipeModule,
    InputDecimalRestrictionModule,
    GoogleTagManagerModule,
    HotjarModule,
    InputRestrictionModule,
    Daterangepicker,
    ToNumberModule,
    TreeDropdownModule,
  ],
  declarations: [
    HeaderComponent,
    EditSuppliersComponent,
    FeasibilityComponent,
    FooterComponent,
    CpiComponent,
    CpiOverrideConfirmationComponent,
    CpiOverrideWarningComponent,
    CreateSurveyDataComponent,
    EditSupplierGroupModalComponent,
    ProcessingComponent,
    EllipsisLoaderComponent,
    TruncateWordPipe,
    TemplateModalComponent,
    DeleteTemplateModalComponent,
    EditSuppliersModalComponent,
    SupplierAllocationModalComponent,
    HeaderServiceAccountComponent,
    AdvanceFeasibilityComponent,
    BlendModalComponent,
    SortPipe,
  ],
  exports: [
    HeaderComponent,
    EditSuppliersComponent,
    EditSuppliersModalComponent,
    EditSupplierGroupModalComponent,
    FooterComponent,
    CpiOverrideConfirmationComponent,
    CpiOverrideWarningComponent,
    CreateSurveyDataComponent,
    HeaderServiceAccountComponent,
    EllipsisLoaderComponent,
  ],
  providers: [DecimalPipe, TitleCasePipe],
})
export class LayoutModule {}
